import { useAuthStore, useShallow } from '../../../store';

import type { ElemasonAuthStepperWidget } from '@tectonic/types';
import type { AuthStore } from '../../../store';

const authSelector = (state: AuthStore) => ({
  setStep: state.setStep,
  currentMode: state.currentMode,
});

const useAuthStepper = (widget: ElemasonAuthStepperWidget) => {
  const wConfig = widget.config ?? {};
  const wData = widget.data!;

  const { setStep, currentMode } = useAuthStore(useShallow(authSelector));
  const isActive = wData.mode === currentMode;

  const config = isActive ? wConfig.cta?.active : wConfig.cta?.inactive;

  const onClick = () => {
    setStep(wData.step, { mode: wData.mode });
  };

  return { config, onClick };
};

export { useAuthStepper };
